import {Injectable} from '@angular/core';
import {LocalStorageService} from './local-storage.service';

@Injectable({
  providedIn: 'root'
})
export class TableViewStorageService {

  constructor(
    private localStorageService: LocalStorageService
  ) {
  }

  getColumns(
    tableName: string,
    availableColumns: string[],
    defaultColumns: string[] = availableColumns
  ): string[] {
    const key = this.getColumnsKey(tableName);

    const savedColumns = this.localStorageService.get<string[]>(key);

    if (savedColumns === null) {
      const initialColumns = defaultColumns.filter(
        (column: string) => availableColumns.indexOf(column) !== -1
      );

      this.setColumns(tableName, initialColumns);
      return initialColumns;
    }

    const columns = savedColumns.filter((column: string) => availableColumns.indexOf(column) !== -1);

    if (columns.length !== savedColumns.length) {
      this.setColumns(tableName, columns);
    }

    return columns;
  }

  setColumns(tableName: string, columns: string[]): void {
    this.localStorageService.set<string[]>(this.getColumnsKey(tableName), columns);
  }

  resetColumns(tableName: string): void {
    this.localStorageService.remove(
      this.getColumnsKey(tableName)
    );
  }

  private getColumnsKey(tableName: string): string {
    return `table.${tableName}.columns`;
  }
}
